document.addEventListener('DOMContentLoaded', function () {
    var carouselList = document.querySelector('#product-splide .splide__list');
    var splideRoot = document.querySelector('#product-splide');
    var productName = document.querySelector('#product-name-title');
    var productLowStock = document.querySelector('#product-low-stock');
    var productLowStockMobile = document.querySelector('#product-low-stock-mobile');
    var addToCartBtn = document.querySelectorAll('.addToCartBtn');
    var addSampleBtn = document.querySelectorAll('.addSampleBtn');
    var soldOutSpan = document.querySelectorAll('.soldOut');
    var splideInstance = null;
    if (window.Splide && splideRoot) {
        splideInstance = splideRoot.splide || null;
    }
    if (!carouselList) return;

    function buildSplideSlides(urls) {
        var list = document.createElement('ul');
        list.className = 'splide__list';
        urls.forEach(function (url) {
            var li = document.createElement('li');
            li.className = 'splide__slide';
            var img = document.createElement('img');
            img.src = url;
            img.className = 'products__carousel-img carousel__img img--full';
            img.loading = 'lazy';
            li.appendChild(img);
            list.appendChild(li);
        });
        return list;
    }

    function buildSplideArrows() {
        var arrows = document.createElement('div');
        arrows.className = 'splide__arrows absolute flex--justify';
        arrows.innerHTML = `
            <button class="splide__arrow splide__arrow--prev">
                <img src="/img/icons/arrow_left.svg" />
            </button>
            <button class="splide__arrow splide__arrow--next">
                <img src="/img/icons/arrow_right.svg"/>
            </button>
        `;
        return arrows;
    }

    function rebuildSplide(urls) {
        // Destroy Splide if exists
        if (window.Splide && splideRoot && splideRoot.splide) {
            splideRoot.splide.destroy(true);
        }
        // Remove all dynamic Splide elements
        var toRemove = splideRoot.querySelectorAll('.splide__pagination, .splide__arrows, .splide__track, .splide__list, .splide__slide');
        toRemove.forEach(function (el) { el.remove(); });
        // Build Splide structure
        var track = document.createElement('div');
        track.className = 'splide__track relative';
        track.appendChild(buildSplideSlides(urls));
        track.appendChild(buildSplideArrows());
        splideRoot.appendChild(track);
        // Re-initialize Splide
        var newSplide = new Splide(splideRoot, {
            type: 'slide',
            arrows: true,
            pagination: true,
            autoplay: true,
            interval: "5000",
            pauseOnHover: true,
            rewind: true
        });
        newSplide.mount();
        splideRoot.splide = newSplide;

        // Hide arrows if only one slide
        if (urls.length === 1) {
            var arrows = splideRoot.querySelector('.splide__arrows');
            if (arrows) {
                arrows.style.display = 'none';
            }
        }
    }

    document.querySelectorAll('.products__child').forEach(function (child) {
        child.addEventListener('click', function () {
            console.log("swap");
            console.log(this);

            // Get product data
            var dId = this.getAttribute('data-id');
            var dTitle = this.getAttribute('data-title');
            var dImg = this.getAttribute('data-images');
            var dPrice = this.getAttribute('data-price') || "";
            var dSku = this.getAttribute('data-sku');
            var dSampleId = this.getAttribute('data-sampleId');
            var dSwatch = this.getAttribute('data-swatch'); // Add this if you have swatch image url
            var dSalesState = this.getAttribute('data-salesState');

            // Update slider Add to Cart button
            var sliderAddToCart = document.querySelector('.products__slider-add-to-cart');
            if (sliderAddToCart) {
                sliderAddToCart.dataset.productId = dId;
                sliderAddToCart.dataset.productName = dTitle;
                sliderAddToCart.dataset.productImg = dImg;
                sliderAddToCart.dataset.productPrice = dPrice;
                sliderAddToCart.dataset.productSku = dSku;
                sliderAddToCart.dataset.productSalesState = dSalesState;
                if (dSalesState == "Sold Out") {
                    sliderAddToCart.style.display = "none";
                } else {
                    sliderAddToCart.style.display = "flex";
                }
                if (dSalesState == "Low Stock") {
                    productLowStock.style.display = "inline";
                    productLowStockMobile.style.display = "inline";
                } else {
                    productLowStock.style.display = "none";
                    productLowStockMobile.style.display = "none";
                }
            }

            // Update slider Download button
            var sliderDownload = document.querySelector('.products__slider-download');
            if (sliderDownload) {
                if (dSwatch && dSwatch !== "") {
                    sliderDownload.href = dSwatch;
                    sliderDownload.style.display = "";
                } else {
                    sliderDownload.href = "#";
                    sliderDownload.style.display = "none";
                }
            }

            if (dImg) {
                var urls = dImg.split(',').filter(Boolean);
                rebuildSplide(urls);
            }

            productName.textContent = dTitle;

            console.log(dId);
            console.log(dTitle);
            console.log(addSampleBtn);

            if (addSampleBtn) {
                addSampleBtn.forEach(function (atc) {
                    console.log(dId);
                    atc.dataset.productId = dSampleId;
                    atc.dataset.productName = dTitle;
                    atc.dataset.productImg = dImg;
                    atc.dataset.productPrice = dPrice;
                    atc.dataset.productSku = dSku;
                    atc.dataset.productSalesState = dSalesState;
                })
            }

            if (addToCartBtn) {
                addToCartBtn.forEach(function (atc) {
                    console.log(dId);
                    atc.dataset.productId = dId;
                    atc.dataset.productName = dTitle;
                    atc.dataset.productImg = dImg;
                    atc.dataset.productPrice = dPrice;
                    atc.dataset.productSku = dSku;
                    atc.dataset.productSalesState = dSalesState;

                    if (dSalesState == "Sold Out") {
                        atc.style.display = 'none';
                    } else {
                        atc.style.display = 'flex';
                    }

                })
            }

            if (soldOutSpan) {
                soldOutSpan.forEach(function (sOS) {
                    if (dSalesState == "Sold Out") {
                        sOS.style.display = 'flex';
                    } else {
                        sOS.style.display = 'none';
                    }

                })
            }


        });
    });
});